<template>
    <ul :class=ul_class v-if="categories.length > 0">
        <li v-for="category in categories" :class="{'show_children' : category.children_show}">
            <a href="javascript:void(0);" v-on:click.prevent class="waves-effect waves-themed " :class="{'active_filter':is_active_categ(category),}">
                <strong class="dl-ref bg-success-500 hidden-sm-down" v-on:click.self="setActive(category)" v-if="category.published">active</strong>
                <strong class="dl-ref bg-danger-500" v-on:click.self="setActive(category)" v-if="!category.published">active</strong>
                <span class="nav-link-text color-black" :class="{'text-muted': !category.published}" v-on:click.self="setActive(category)">
                    <div>
                        <div>
                            {{ category.title }}
                            <span class="small text-info">
                                <i class="fal fa-lock" v-if="category.skeep_sync"></i>
                            </span>

                            <span class="small text-info">
                                <i class="fal fa-hashtag" v-if="category.category_mode == 'tag'"></i>
                            </span>

                            <span class="small badge border border-primary text-primary" v-if="category.adv_name.length > 0">
                                {{ category.adv_name }}
                            </span>
                            <!--
                            <div class="mt-1" >
                                <div class="small very_small badge border border-info  text-info mr-1 " v-for="prov in category.visible_providers" v-if="category.hasOwnProperty('visible_providers')">
                                    <span v-if="prov.is_on">{{ prov.human_name }}</span>
                                </div>
                                <div class="small badge border border-warning text-black-50  mr-1">
                                    {{category.prov_name}}
                                </div>
                            </div>
                            -->

                        </div>
                    </div>
                </span>
                <b class="collapse-sign color-black" v-if="category.children.length > 0 && depth == 0">
                    <em class="fal fa-angle-down color-black children_info" v-on:click.stop.prevent="show_children(category)"></em>
                </b>
                <i class="fal fa-cog width-2 fs-xxl ml-4" v-on:click.stop="edit(category)"></i>
            </a>

            <categ_sub  :depth="1" :categories="category.children" v-if="category.children.length > 0"></categ_sub>
        </li>
    </ul>
</template>

<script>
    import {createHelpers} from 'vuex-map-fields';
    import {mapGetters} from "vuex";


    const {mapFields} = createHelpers({
        getterType: 'inbox_state/getInboxStateField',
        mutationType: 'inbox_state/updateInboxStateField',
    });


    export default {
        name: "categ_sub",
        props : {
            categories : Array,
            depth : {
                type : Number,
                default : 0
            }
        },
        methods : {
            is_active_categ(categ) {
                let is_active = false;
                this.active_filter_categ.map(id => {
                    if (parseInt(id) === parseInt(categ.id)) {
                        is_active = true;
                    }
                });
                return is_active;
            },

            setActive(categ) {
                let to_send_categ = [];
                if (this.active_filter_categ.length > 0) {
                    this.active_filter_categ.map(id => {
                        to_send_categ.push(parseInt(id))
                    })
                }

                if (to_send_categ.includes(parseInt(categ.id))) {
                    let n_to_send = [];
                    to_send_categ.map(id => {
                        if (parseInt(categ.id) !== parseInt(id)) {
                            n_to_send.push(id)
                        }
                    });

                    to_send_categ = n_to_send;
                } else {
                    to_send_categ.push(parseInt(categ.id))
                }


                if (to_send_categ.length === 0) {
                    //FUCK me
                    to_send_categ = JSON.stringify([]);
                }

                EventBus.$emit('filter_select_change', {
                    "type": "categories",
                    "value": to_send_categ
                });
            },

            show_children(category) {
                category.children_show = !category.children_show;
            },

            edit(category) {
                EventBus.$emit("categ_edit", parseInt(category.id));
            }
        },
        computed : {

            ...mapFields([
                'all_filter',
                'filter'
            ]),

            active_org_id () {
                if (this.all_filter.hasOwnProperty('org_id')) {
                    return this.all_filter.org_id;
                }

                return 0;
            },

            active_filter_categ: {
                get: function () {
                    if (this.all_filter.hasOwnProperty('categories')) {
                        if (this.all_filter.categories == null) {
                            return [];
                        }
                        return this.all_filter.categories;
                    }
                    return [];
                },
                set: function (newValue) {
                    //Set active categs
                }
            },

            ul_class () {
                if(this.depth > 0) {
                    return "categ_bg";
                }
                return "nav-menu  mb-sm-4 mb-md-0 rounded";
            }
        }
    }
</script>

<style scoped>
    .categ_bg {
        background-color: #eeeeee2e;
    }

    .very_small {
        font-size: 50%;
    }

    .children_info {
        width: 15px;
        height: 15px;
        cursor: row-resize;
        text-align: center;
    }

    a.active_filter {
        border-left: 3px solid #584475;
        background: #eee;
    }

    li.show_children ul {
        display: block;
    }
</style>
